import React, { Fragment } from 'react'
import Loadable from 'react-loadable'
import { DI } from 'modules'
import HelmetWrap from 'components/helmet-wrap'
import HTMLTranslation from 'components/html-translation'
import page from 'hoc/page'
import frontload from 'hoc/frontload'

import 'submodules/responsivestyles/src/less/about.less'
import { IS_LANDING } from 'config'

const loading = () => null
const en = Loadable({
  loading,
  loader: () =>
  IS_LANDING ? 
    import(
      /* webpackChunkName: "cookie-policy-en" */ 'submodules/translations/static-pages/cookie-policy-landing/en'
    ) : import(
      /* webpackChunkName: "cookie-policy-en" */ 'submodules/translations/static-pages/cookie-policy/en'
    )
})
const ru = Loadable({
  loading,
  loader: () =>
  IS_LANDING ? 
    import(
      /* webpackChunkName: "cookie-policy-ru" */ 'submodules/translations/static-pages/cookie-policy-landing/ru'
    ) : import(
      /* webpackChunkName: "cookie-policy-ru" */ 'submodules/translations/static-pages/cookie-policy/ru'
    )
})
const es = Loadable({
  loading,
  loader: () =>
  IS_LANDING ? 
    import(
      /* webpackChunkName: "cookie-policy-es" */ 'submodules/translations/static-pages/cookie-policy-landing/es'
    ) : import(
      /* webpackChunkName: "cookie-policy-es" */ 'submodules/translations/static-pages/cookie-policy/es'
    )
})
const ar = Loadable({
  loading,
  loader: () =>
  IS_LANDING ? 
    import(
      /* webpackChunkName: "cookie-policy-ar" */ 'submodules/translations/static-pages/cookie-policy-landing/ar'
    ) : import(
      /* webpackChunkName: "cookie-policy-ar" */ 'submodules/translations/static-pages/cookie-policy/ar'
    )
})

export class CookiePage extends React.Component {
  static preload(props) {
    const slug = 'cookie'
    return props.actions.frontpages.getFrontPage(slug)
  }

  render() {
    const meta_tag = this.props.frontpages.info.payload.meta_tag
    return (
      <Fragment>
        <HelmetWrap {...(meta_tag || {})} page="cookies" />

        <section className="content">
          <div className="iwrap not-found-page">
            <div className="about-container">
              <HTMLTranslation translations={{ en, ru, es, ar }} />
            </div>
          </div>
        </section>
      </Fragment>
    )
  }
}

export default page(DI(['frontpages'])(frontload(CookiePage, 'cookiePage')))
